import React from 'react'

const WireInfo = ({ i18n, currency }) =>
  <div className="col-sm">
    <div className="h-card vcard mb-3">
      <h6>{i18n.t('deferred.receiving_bank')}</h6>
      <div className="p-name p-org fn org">Silicon Valley Bank</div>
      <div>
        <span className="h-adr adr">
          <span className="p-street-address street-address">
            3003 Tasman Drive
          </span>
          <br/>
          <span className="p-locality locality">Santa Clara</span>{', '}
          <abbr className="p-region region" title="California">CA</abbr>{' '}
          <span className="p-postal-code postal-code">95054</span>{' '}
          <abbr className="p-country-name country-name" title="United States">
            USA
          </abbr>
        </span>
      </div>
    </div>

    <div className="mb-3">
      <div>
        <b className="text-nowrap">{i18n.t('deferred.routing_number')}:</b>{' '}
        121140399
      </div>
      <div>
        <b className="text-nowrap">{i18n.t('deferred.swift_code')}:</b>{' '}
        <span className="text-nowrap">
          SVBKUS6SXXX {i18n.t('deferred.or')} SVBKUS6S
        </span>
      </div>
    </div>

    <div className="mb-3">
      <div>
        <b className="text-nowrap">{i18n.t('deferred.account_number')}:</b>{' '}
        3303866848
      </div>
      <div>
        <b className="text-nowrap">{i18n.t('deferred.account_type')}:</b>{' '}
        {i18n.t('deferred.checking')}
      </div>
      <div>
        <b className="text-nowrap">{i18n.t('currency')}:</b>{' '}
        {currency.iso_code}
      </div>
    </div>
  </div>

const WireCheckInfo = ({ i18n, currency, paymentOption, address, ein }) =>
  <div>
    <p>{i18n.t('deferred.intro')}</p>

    <div className="row">
      <div className="col-sm">
        <div className="h-card vcard mb-3">
          <h6>
            {(() => {
              switch (paymentOption) {
              case 'wire': return i18n.t('deferred.wire_money_to')
              case 'check': return i18n.t('deferred.make_check_payable_to')
              }
            })()}
          </h6>
          <div className="p-name p-org fn org">Pledgeling Foundation</div>
          <div className="mb-3" dangerouslySetInnerHTML={{ __html: address }}/>
          <div>
            <b className="text-nowrap">{i18n.t('email')}:</b>{' '}
            <span className="u-email email">accounting@pledgeling.org</span>
          </div>
          <div>
            <b className="text-nowrap">EIN:</b>{' '}{ein}
          </div>
        </div>
      </div>

      {paymentOption == 'wire' && <WireInfo i18n={i18n} currency={currency} />}
    </div>
  </div>

const BankInfo = ({ i18n, currency, paymentOption, address, ein }) =>
  <div className="bank-info bg-light px-3 py-4 px-sm-4 rounded-4">
    <div className="bank-info-inner mb-n3">
      {
        paymentOption == 'tbd'
        ? <p>{i18n.t('deferred.pledge_instructions')}</p>
        : <WireCheckInfo
            i18n={i18n}
            currency={currency}
            paymentOption={paymentOption}
            address={address}
            ein={ein}
          />
      }
    </div>
  </div>

export default BankInfo
